export enum ReportTypeEnum {
  PalletTag = 0,
  PickTicket = 1
}
